// @core/api/endpoints/legalentity/update_default_signatory.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  LegalEntityResponse,
  UpdateDefaultSignatoryRequest,
} from '../../../types/legalentity';

const BASE_PATH = '/legalentity';

/**
 * Update default signatory
 * Replaces the default signatory (position, name, basis, optional PoA) for the legal entity. Emits legal_entity.signatory_changed so drafts can re-render the preamble.
 */
export async function UpdateDefaultSignatory(
  legal_entity_id: string,
  data: UpdateDefaultSignatoryRequest,
  options?: RequestOptions
): Promise<LegalEntityResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:legal_entity_id/signatory`;
  requestPath = requestPath.replace(':legal_entity_id', encodeURIComponent(legal_entity_id));
  const requestOptions = options;
  return client.put<LegalEntityResponse>(requestPath, data, requestOptions);
}
